import React, { useEffect, useState, useCallback } from "react";

import { __t } from "@/utils/translate";
import { Product } from "@/utils/types";
import { useOptions } from "@/hooks/useOptions";

const Context = React.createContext(null);

type ProductProviderProps = {
    product: Product;
};

const ProductProvider: React.FC<ProductProviderProps> = ({ children, ...props }) => {
    const context = useCreateProductContext(props);
    return <Context.Provider value={context}>{children}</Context.Provider>;
}

export default ProductProvider;

const getDefaultAttributes = (product: Product) => {
    const attributes = {};
    product.default_attributes.map((attribute) => {
        let product_attribute = product.variation_attributes.find((attr) => attr.id && attr.id == attribute.id)
        if (!product_attribute) {
            product_attribute = product.variation_attributes.find((attr) => attr.name === attribute.name)
        }

        if (product_attribute) {
            attributes[product_attribute.slug] = attribute.option;
        }
    });
    return attributes;
}

const useCreateProductContext = function (props) {
    const [product, setProduct] = useState(props.product || null);
    const [quantity, setQuantity] = useState(1);
    const [isOutOfStock, setIsOutOfStock] = useState(false);

    const [image, setImage] = useState(product.image);


    const options = useOptions();
    const [currency_symbol, setCurrencySymbol] = useState(options.wpOptions.data.currency_symbol);

    const [attributes, setAttributes] = useState(getDefaultAttributes(product));
    const setAttribute = (attribute) => {
        selectVariation({ ...attributes, ...attribute });
    };
    const selectVariation = (attributes) => {
        let t_var = product.variations_product.find((variation) => {
            let attributes_find = variation.attributes2.filter(attr => {
                return attributes[attr.attribute] == attr.value;
            })

            return attributes_find.length === variation.attributes2.length;
        });

        if (t_var && t_var.id) {
            setVariationId(t_var.id);
        }
        setAttributes(attributes);
    }

    const [activePicture, setActivePicture] = useState(0);
    const [variationId, setVariationIdValue] = useState(product.defaultVariationID);
    const setVariationId = (value) => {
        setVariationIdValue(value);
        const variation = product.variations_product.find((variation) => variation.id === value);
        if (variation?.image?.localFile) {
            if (variation.image.id !== image.id) {
                setImage(variation.image);
                setActivePicture(0);
            }
        }
    }

    return {
        product,
        image,
        currency_symbol,
        quantity,
        setQuantity,
        variationId,
        setVariationId: setVariationIdValue,
        attributes,
        setAttribute,
        activePicture,
        setActivePicture,
        isOutOfStock,
        setIsOutOfStock
    };
}

export const useProductContext = () => {
    const context = React.useContext(Context);
    if (!context) throw new Error('Use app context within provider!');
    return context;
}

// function count() {
//     const context = useAppContext();
//     if (!context) throw new Error('Use app context within provider!');
//     context.count;
// }

// function increment() {
//     const context = useAppContext();
//     if (!context) throw new Error('Use app context within provider!');
//     context.increment();
// }
